import { Cloud } from "phosphor-react";
import React from "react";


const colorVariants = {
  orange:{
    bgHeader:"bg-amber-400/10 dark:bg-amber-400/10",
    iconColor:"bg-orange-500"
  ,},
  blue:{
    bgHeader:"bg-blue-400/10 dark:bg-blue-400/10",
    iconColor:"bg-blue-500"
  }
  
};
  function MyCard6({ className = "", children ,onClick,title="",subtitle="",icon,color="orange"}) {
      const varient= colorVariants[color]||colorVariants.orange;
      const Icon=icon??Cloud
  return (
    <div
    onClick={() => onClick && onClick()}
      className={`w-full   ${className} rounded-xl backdrop-blur-sm bg-white dark:bg-slate-300/20 border border-input border-gray-300/60 dark:border-gray-400/30  shadow-2xs `}

    >
      <div className={`flex px-4 py-3 space-x-2 items-center justify-start ${varient.bgHeader} rounded-t-xl`}>
       <Icon size={36} weight="bold" className={`p-2 text-white  ${varient.iconColor} rounded-xl  shadow-sm`}/>
        <div className="flex flex-col">
          <h1 className="text-sm font-semibold text-slate-800 dark:text-slate-200">{title}</h1>
          <span className="text-[11px] font-light text-slate-800 dark:text-slate-200">{subtitle}</span>
        </div>
      </div>
      {children}
    </div>
  );
}
export default MyCard6;
